@layer tbw-plugins {
  .tbw-visibility-content {
    display: flex;
    flex-direction: column;
    height: 100%;
  }

  .tbw-visibility-list {
    flex: 1;
    overflow-y: auto;
    padding: var(--tbw-panel-padding, var(--tbw-spacing-md, 0.5rem));
  }

  .tbw-visibility-row {
    display: flex;
    align-items: center;
    gap: var(--tbw-panel-gap, var(--tbw-spacing-md, 0.5rem));
    padding: var(--tbw-menu-item-padding, 0.375rem 0.25rem);
    cursor: pointer;
    font-size: var(--tbw-font-size-sm, 0.8125rem);
    border-radius: var(--tbw-border-radius, 0.25rem);
    position: relative;
  }
  .tbw-visibility-row:hover {
    background: var(--tbw-visibility-hover, var(--tbw-color-row-hover));
  }
  .tbw-visibility-row input[type='checkbox'] {
    cursor: pointer;
  }
  .tbw-visibility-row.locked span {
    color: var(--tbw-color-fg-muted);
  }

  /* Drag handle */
  .tbw-visibility-handle {
    cursor: grab;
    color: var(--tbw-color-fg-muted);
    font-size: var(--tbw-font-size-2xs, 0.625rem);
    letter-spacing: -2px;
    user-select: none;
    flex-shrink: 0;
  }
  .tbw-visibility-row.reorderable:hover .tbw-visibility-handle {
    color: var(--tbw-color-fg);
  }
  /* Label wrapper for checkbox and text */
  .tbw-visibility-label {
    display: flex;
    align-items: center;
    gap: var(--tbw-panel-gap, var(--tbw-spacing-md, 0.5rem));
    flex: 1;
    cursor: pointer;
  }

  /* Drag states */
  .tbw-visibility-row.dragging {
    opacity: 0.5;
    cursor: grabbing;
  }
  .tbw-visibility-row.drop-before::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 2px;
    background: var(--tbw-visibility-indicator, var(--tbw-color-accent));
  }
  .tbw-visibility-row.drop-after::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    background: var(--tbw-visibility-indicator, var(--tbw-color-accent));
  }

  .tbw-visibility-show-all {
    margin: var(--tbw-panel-padding, var(--tbw-spacing-md, 0.5rem));
    padding: var(--tbw-button-padding, 0.5rem 0.75rem);
    border: 1px solid var(--tbw-visibility-border, var(--tbw-color-border));
    border-radius: var(--tbw-border-radius, 0.25rem);
    background: var(--tbw-visibility-btn-bg, var(--tbw-color-header-bg));
    color: var(--tbw-color-fg);
    cursor: pointer;
    font-size: var(--tbw-font-size-sm, 0.8125rem);
  }
  .tbw-visibility-show-all:hover {
    background: var(--tbw-visibility-hover, var(--tbw-color-row-hover));
  }

  /* Group header */
  .tbw-visibility-group-header {
    display: flex;
    align-items: center;
    padding: var(--tbw-menu-item-padding, 0.375rem 0.25rem);
    font-size: var(--tbw-font-size-sm, 0.8125rem);
    font-weight: 600;
    color: var(--tbw-color-fg);
    border-bottom: 1px solid var(--tbw-color-border);
    margin-top: var(--tbw-spacing-sm, 0.25rem);
    position: relative;
  }
  .tbw-visibility-group-header:first-child {
    margin-top: 0;
  }
  .tbw-visibility-group-header .tbw-visibility-label {
    gap: var(--tbw-panel-gap, var(--tbw-spacing-md, 0.5rem));
  }

  /* Reorderable group header */
  .tbw-visibility-group-header.reorderable {
    cursor: grab;
  }
  .tbw-visibility-group-header.reorderable:hover {
    background: var(--tbw-visibility-hover, var(--tbw-color-row-hover));
  }
  .tbw-visibility-group-header .tbw-visibility-handle {
    cursor: grab;
    color: var(--tbw-color-fg-muted);
    font-size: var(--tbw-font-size-2xs, 0.625rem);
    letter-spacing: -2px;
    user-select: none;
    flex-shrink: 0;
  }
  .tbw-visibility-group-header.reorderable:hover .tbw-visibility-handle {
    color: var(--tbw-color-fg);
  }

  /* Coarse pointer (touch): handles always in active colour and large enough to tap */
  @media (hover: none) {
    .tbw-visibility-row.reorderable .tbw-visibility-handle,
    .tbw-visibility-group-header.reorderable .tbw-visibility-handle {
      color: var(--tbw-color-fg);
    }
  }

  @media (pointer: coarse) {
    .tbw-visibility-handle {
      min-width: var(--tbw-touch-target-min, 24px);
      min-height: var(--tbw-touch-target-min, 24px);
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
  }

  /* Group drag states */
  .tbw-visibility-group-header.dragging {
    opacity: 0.5;
    cursor: grabbing;
  }
  .tbw-visibility-group-header.drop-before::before {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    height: 2px;
    background: var(--tbw-visibility-indicator, var(--tbw-color-accent));
  }
  .tbw-visibility-group-header.drop-after::after {
    content: '';
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    height: 2px;
    background: var(--tbw-visibility-indicator, var(--tbw-color-accent));
  }

  /* Indented column rows within a group */
  .tbw-visibility-row--grouped {
    padding-left: calc(var(--tbw-panel-padding, var(--tbw-spacing-md, 0.5rem)) + 0.75rem);
  }

  /* ===== Handle move menu (WCAG 2.2 SC 2.5.7) ===== */

  .tbw-visibility-move-menu {
    position: fixed;
    margin: 0;
    padding: 4px;
    display: flex;
    flex-direction: column;
    min-width: 10rem;
    background: var(--tbw-color-panel-bg, light-dark(#fff, #1e1e1e));
    color: var(--tbw-color-panel-fg, light-dark(#1a1a1a, #eaeaea));
    border: 1px solid var(--tbw-color-border, light-dark(#d0d0d0, #3a3a3a));
    border-radius: var(--tbw-border-radius, 0.25rem);
    box-shadow: var(--tbw-shadow-panel, 0 4px 12px light-dark(rgb(0 0 0 / 20%), rgb(0 0 0 / 50%)));
    font: inherit;
    z-index: 10001;

    &[hidden] {
      display: none;
    }
  }

  .tbw-visibility-move-menu-item {
    min-height: var(--tbw-touch-target-min, 24px);
    padding: 4px 8px;
    text-align: start;
    background: none;
    color: inherit;
    font: inherit;
    border: 0;
    /* Themes set radii for much larger surfaces (Material uses 12px), which
       turns a 24px row into a lozenge. */
    border-radius: min(var(--tbw-border-radius, 0.25rem), 6px);
    cursor: pointer;

    &:hover:not(:disabled) {
      background: var(--tbw-color-row-hover, light-dark(#00000010, #ffffff14));
    }

    &:disabled {
      opacity: 0.5;
      cursor: default;
    }
  }
} /* End @layer tbw-plugins */
